export interface Epdresponse {
  available_pcrs: PCR[];
  data: {
    available_exports: Export[];
    sections: Section[];
    tables: Tables;
    metadata: Metadata;
    standard: string;
    charts: Chart[];
    pcr: PCR;
    pdf_export_data: {
      standard_logo: string;
      product_image_url: string;
      company_logo_url: string;
      cover_page: {
        title: string;
        profile_table: any;
      };
      additional_data: {
        epd_statment: string;
        long_company_name: string;
        customer_care_contact: string;
        company_address: string;
      };
    };
  };
}

export interface Export {
  key: string;
  label: string;
  sections?: Section;
  url?: string;
}

export interface Metadata {
  UUID: null;
  product_image_url: null;
  company_logo_url: null;
  name: string;
  product_purpose: null;
  range_description: string;
  functional_unit: string;
  specifications_text: string;
  reference_flow: null;
  tech_description: string;
  reference_year: string;
  time_span: number;
  time_span_unit: string;
  location: null;
  product_category: null;
  electricity_consumption: null;
  installation_elements: string;
  use_scenario: string;
  assembly_site_geo: string;
  use_phase_geo: string;
  eol_geo: string;
  pep_registration_number: string;
  pep_drafting_rules: string;
  supplemented_by: null;
  verifier_accreditation_number: string;
  validity_period: string;
  review_type: null;
  user_name: null;
  long_company_name: string;
  customer_care_contact: string;
  company_address: string;
  short_company_name: string;
  company_web_address: string;
  footnote: string;
  pep_code: null;
  database_version: null;
  software_version: null;
  verification_date: null;
  pcr_name: null;
  commercial_reference_number: null;
  data_source: null;
  energy_covered_products: null;
  time_representativeness: null;
  product_range_justification: null;
  energy_consumption_lifetime: null;
}

export interface Tables {
  climate_section: Section;
  eutrophic_section: Section;
}

export interface Chart {
  key: string;
  title: string;
  items: any;
  sort_level: number;
}

export interface PCR {
  rid: string;
  name: string;
  declared_unit: string;
  category: string;
  updated?: string;
  layers?: any[];
  text_section?: string;
  pcr?: PCR;
}

export interface Standard {
  name: string;
  text: string;
  value: string;
}

export interface Section {
  headers: string[];
  rows: Row[];
  title: string;
  sort_level: number;
  key?: string;
}

export interface Row {
  name: string;
  rid: string;
  unit: string;
  stages: Stage[];
  sortlevel: number;
}

export interface Stage {
  name: string;
  value: number;
}
export const seENVs: string[] = [
  'se.makersite.app',
  'schneiderelectric-08b0.sbx.makersite.app',
  'schneider-uat.makersite.app',
  'seintegration-ae4b.sbx.makersite.app',
  'se-93d7.sbx.makersite.app',
  'schneider3101-c6a3.sbx.makersite.app',
  'schneider-3-10-1-5c26.sbx.makersite.app'
];

export const enum EPD_STANDARDS {
  EF_30 = 'ef_3.0',
  PEP_ECOPASSPORT = 'pep_ecopassport',
  RECIPE_2016_MIDPOINT_H = 'recipe_2016_midpoint_h',
  EN_15804_A2 = 'en15804_a2'
}

export const enum EPD_STANDARD_LABELS {
  EF_30 = 'EF 3.0',
  PEP_ECOPASSPORT = 'PEP Ecopassport',
  RECIPE_2016_MIDPOINT_H = 'ReCiPe 2016 Midpoint (H)',
  EN_15804_A2 = 'EN 15804 + A2'
}
